export default __webpack_public_path__ + "static/media/ios.1a573cac.png";